import { HOC_MDXWrapper } from 'nextra/setup-page'
import { pageMap } from '/vercel/path0/.next/static/chunks/nextra-page-map-.mjs'
/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "First Automation";
const frontMatter = {
  "title": "First Automation",
  "description": "Pluto — The API for personal web data. Embed it in your app to authenticate users, share data and perform actions on their behalf for any site on the internet."
};
import {Callout} from "nextra/components";
import DeviceInstallLinksMarkdown from "@/components/DeviceInstallLinksMarkdown";
import FirstAutomation from "@/components/FirstAutomation";
export function useTOC(props) {
  return [{
    value: "First Automation",
    id: "first-automation",
    depth: 2
  }];
}
function MDXLayout(props) {
  const {toc = useTOC(props)} = props;
  const _components = {
    h2: "h2",
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return <><_components.h2 id={toc[0].id}>{toc[0].value}</_components.h2>{"\n"}{"\n"}<_components.p>{"In this example, you’ll see what an Embedded Automation looks like for your users, via the Pluto Frame."}</_components.p>{"\n"}<_components.p>{"By embedding the Pluto Frame into your app, you can invoke secure, TEE-backed automation scripts and collect verifiable proofs; all while preserving user anonymity and data privacy."}</_components.p>{"\n"}<_components.p>{"For example, your users might prove their bank balance, their venmo transaction history, or follower count on a social feed — without ever sharing their login or personal history."}</_components.p>{"\n"}{"\n"}<FirstAutomation /></>;
}


export default HOC_MDXWrapper(
  MDXLayout,
  '/getting-started/first-automation',
  {"filePath":"pages/getting-started/first-automation.mdx","timestamp":1746474785000,pageMap,frontMatter,title},
  typeof RemoteContent === 'undefined' ? useTOC : RemoteContent.useTOC
)